import { CompanyProfile } from '@aibees/elephant/components/company-profile';
import { memo } from 'react';
import { usePersonCompanyInfo } from '../../../../hooks/people/use-person-company-info';
import type { CompanyOfPersonProps as Props } from './types';

const AVATAR_SIZE = 40;
const BADGE_SIZE = 16;

export const CompanyOfPerson = memo(({ className, data }: Props) => {
  const { companyName, showPopover, imageSrc, id, socialLink } =
    usePersonCompanyInfo(data);

  return (
    <CompanyProfile
      className={className}
      name={companyName ?? undefined}
      imageSrc={imageSrc}
      id={id}
      socialLink={socialLink}
      showPopover={showPopover}
      personData={data}
      avatarSize={AVATAR_SIZE}
      badgeSize={BADGE_SIZE}
    />
  );
});

CompanyOfPerson.displayName = 'CompanyOfPerson';
